<template>
  <div class="sys">
    <p style="display: flex;justify-content: center;">
      <img src="@/assets/image/wra.png" alt="" style="width: 130px;">
    </p>
    <div class="ql-editor" style="width:100%" v-html="decodeURIComponent(content)">
      
    </div>
  </div>
</template>

<script>
import {
  getSystemEnDis,
} from "@/api/api";
export default {
  name: 'platformNotifications',
  props: {},
  components: {},
  data () {
    return {
      content: ""
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  methods: {},
  created () {
  },
  async mounted () {
    let res = await getSystemEnDis({ token: 1111 });
    // if (res.data.status == 1) {

    // }
    this.content = res.data.content;
  },
}
</script> 

<style lang='scss' scoped>
.sys {
  padding: 12px;
}
@import "../../style/quill.bubble.css";
@import "../../style/quill.core.css";
@import "../../style/quill.snow.css";
</style>
